<template>
  <div class="console-page feedback-view">
    <h1 class="console-page__title">Feedback</h1>
    <p class="console-page__subtitle">
      Submitted user feedback and issue reports
    </p>

    <a-card :bordered="false" class="console-card">
      <template #title>
        <span>All feedback</span>
        <a-tag v-if="pagination" color="blue" class="feedback-view__count-tag">
          {{ pagination }} total
        </a-tag>
      </template>
      <a-table
        :columns="columns"
        :data-source="featureList"
        :loading="confirmLoading"
        :pagination="false"
        :row-key="(row) => row.id"
        bordered
        size="middle"
        class="feedback-view__table"
      />
      <div v-if="pagination > pageSize" class="feedback-view__pagination">
        <a-pagination
          :current="currentPage"
          :total="pagination"
          :page-size="pageSize"
          :hide-on-single-page="true"
          :show-less-items="true"
          @change="onPageChange"
        />
      </div>
      <div
        v-else-if="
          !confirmLoading && (!featureList || featureList.length === 0)
        "
        class="feedback-view__empty-hint"
      >
        No feedback entries yet.
      </div>
    </a-card>
  </div>
</template>

<script>
import { sendRequest } from "@/http/axios.method";
import { message } from "ant-design-vue";

export default {
  name: "Feedback",
  data() {
    return {
      config: {
        Authorization: "Bearer " + this.$store.state.authUser.token,
      },
      feedbacks: [],
      currentPage: 1,
      pageSize: 10,
      pagination: 0,
      confirmLoading: false,
    };
  },
  computed: {
    featureList() {
      return this.feedbacks;
    },
    columns() {
      const page = this.currentPage;
      const size = this.pageSize;
      return [
        {
          title: "#",
          key: "index",
          width: 64,
          align: "center",
          customRender: (text, row, index) => (page - 1) * size + index + 1,
        },
        {
          title: "Type",
          dataIndex: "name",
          width: 160,
        },
        {
          title: "Feedback",
          dataIndex: "title",
        },
      ];
    },
    responseMessage() {
      const msg = this.$store.state.message;
      this.$store.commit("resetMessage");
      return msg;
    },
  },
  created() {
    this.getFeatureList();
  },
  methods: {
    onPageChange(page) {
      this.currentPage = page;
      this.getFeatureList();
    },
    getFeatureList() {
      this.confirmLoading = true;
      const payload = {
        page: this.currentPage,
      };
      sendRequest("get", "admin/get-feedback-list", payload, this.config)
        .then((response) => {
          this.confirmLoading = false;
          if (response.success) {
            const list = response.data.feedbacks.data || [];
            this.feedbacks = list.map((content) => ({
              key: content.id,
              id: content.id,
              name: content.feedback_type,
              title: content.feedback,
            }));
            this.pagination = response.data.feedbacks.total;
            this.currentPage = response.data.feedbacks.current_page;
            if (this.responseMessage !== "") {
              message.success(this.responseMessage);
            }
          } else if (response.status_code === 401) {
            this.$store.dispatch("logout");
            this.$router.push("/login");
          }
        })
        .catch(() => {
          this.confirmLoading = false;
        })
        .finally(() => {
          this.confirmLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.feedback-view__count-tag {
  margin-left: 10px;
  font-weight: 600;
  vertical-align: middle;
}

.feedback-view__table {
  margin-top: 4px;
}

.feedback-view__table ::v-deep .ant-table-tbody > tr > td:nth-child(2) {
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.feedback-view__table ::v-deep .ant-table-tbody > tr > td:nth-child(3) {
  max-width: min(560px, 55vw);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.feedback-view__pagination {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
  text-align: right;
}

.feedback-view__empty-hint {
  margin-top: 16px;
  padding: 24px;
  text-align: center;
  color: #8c8c8c;
  font-size: 14px;
  background: #fafafa;
  border-radius: 8px;
}
</style>
